import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { ArrowTopRightOnSquareIcon } from '@heroicons/react/24/outline';
import { cn } from '@/utils/classNames.ts';
import {
  type ControlTone,
  externalLinkClassName,
  externalLinkIconClassName,
} from '@/components/shared/tripControlClassNames.ts';

type PlaceMapsLinkProps = {
  url: string | null;
  placeName: string;
  tone?: ControlTone;
  className?: string;
};

const PlaceMapsLink: FC<PlaceMapsLinkProps> = ({ url, placeName, tone = 'light', className }) => {
  const { t } = useTranslation();

  if (!url) return null;

  return (
    <a
      href={url}
      target="_blank"
      rel="noreferrer"
      aria-label={t('tripPage.open_place_in_google_maps_label', { name: placeName })}
      className={cn(externalLinkClassName(tone), className)}
    >
      {t('tripPage.open_place_in_google_maps')}
      <ArrowTopRightOnSquareIcon className={externalLinkIconClassName(tone)} aria-hidden="true" />
    </a>
  );
};

export default PlaceMapsLink;
